export default __webpack_public_path__ + "static/Group 3-3e96922964c9503282412107cf01c674.jpg";